import { useCurrency } from '../../context/CurrencyContext';
import { CurrencyE } from '../../declarations/enums/currency';

type PricePropsT = {
  amount: number | string;
  currency?: keyof typeof CurrencyE;
  decimal?: number;
  isFormatted?: boolean;
};

export const Price: React.FC<PricePropsT> = ({ amount, currency, decimal = 2, isFormatted }) => {
  const { rate, selectedCurrency } = useCurrency();

  const price = +amount * rate;
  const showCurrency = currency || selectedCurrency;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: showCurrency,
  });

  return (
    <b>{isFormatted ? formatter.format(price) : `${price.toFixed(decimal)} ${showCurrency}`}</b>
  );
};

export default Price;
